import React, { useState } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import DataUpload from "./components/DataUpload";
import SalesDashboard from "./components/SalesDashboard";
import ProductDashboard from "./components/ProductDashboard";
import ProfitDashboard from "./components/ProfitDashboard";
import ComprehensiveDashboard from "./components/ComprehensiveDashboard";
import AnalysisReport from "./components/AnalysisReport";
import AIAssistant from "./components/AIAssistant";

function App() {
  const [activeView, setActiveView] = useState("upload");
  const [dataStatus, setDataStatus] = useState({
    sales: false,
    costs: false,
    raws: false,
  });

  const updateDataStatus = (type, status) => {
    setDataStatus((prev) => ({
      ...prev,
      [type]: status,
    }));
  };

  const renderActiveView = () => {
    switch (activeView) {
      case "upload":
        return (
          <DataUpload
            updateDataStatus={updateDataStatus}
            dataStatus={dataStatus}
          />
        );
      case "analysis":
        return <AnalysisReport />;
      case "sales":
        return <SalesDashboard />;
      case "products":
        return <ProductDashboard />;
      case "profit":
        return <ProfitDashboard />;
      case "dashboard":
        return <ComprehensiveDashboard />;
      case "ai":
        return <AIAssistant />;
      default:
        return (
          <DataUpload
            updateDataStatus={updateDataStatus}
            dataStatus={dataStatus}
          />
        );
    }
  };

  return (
    <div className="App">
      <Navbar
        activeView={activeView}
        setActiveView={setActiveView}
        dataStatus={dataStatus}
      />
      <main className="main-content">{renderActiveView()}</main>
    </div>
  );
}

export default App;
